export default __webpack_public_path__ + "static/8344-c22cc162c2a0ef99d9441fbcf0306b2f.jpg";